module.exports = __webpack_public_path__ + "static/media/location-gris_old.ff095ae8.svg";